import { firestoreAction } from "vuexfire";
import { collection } from "@/store/modules/db";
import { api } from "@/api";
// import deepEqual from "deep-equal";
import firebase from "firebase";
import hive from "@/hive";

export default {
  namespaced: true,
  state: () => ({
    systemTemplates: [],
    customTemplates: [],
    updatingSystemTemplate: false,
    dataInitialised: false,
    currentTemplate: null,
    currentTemplateHtml: null,
    currentSlotValues: {},
    isCurrentTemplateSystem: false
    // currentRenderedHtml: null
  }),
  mutations: {
    dataInitialised(state) {
      state.dataInitialised = true;
    },
    updatingSystemTemplate(state, stat) {
      state.updatingSystemTemplate = stat;
    },
    setCurrentTemplateHtml(state, html) {
      state.currentTemplateHtml = html;
    },
    setCurrentTemplate(state, template) {
      state.currentTemplate = template;
    },
    setCurrentSlotValues(state, slotValues) {
      state.currentSlotValues = slotValues;
    },
    setIsCurrentTemplateSystem(state, is) {
      state.isCurrentTemplateSystem = is;
    }
    // setCurrentRenderedHtml(state, html) {
    //   state.currentRenderedHtml = html;
    // }
  },
  actions: {
    fetch: firestoreAction(context => {
      // context contains all original properties like commit, state, etc
      // and adds `bindFirestoreRef` and `unbindFirestoreRef`
      // we return the promise returned by `bindFirestoreRef` that will
      // resolve once data is ready
      if (context.state.dataInitialised) return true;
      context.commit("dataInitialised");
      const promises = [
        context.bindFirestoreRef(
          "systemTemplates",
          collection("emails/templates/system")
        ),
        context.bindFirestoreRef(
          "customTemplates",
          collection("emails/templates/system")
        )
      ];
      return Promise.all(promises);
    }),
    saveSystemTemplate: firestoreAction(
      ({ commit, state, rootGetters }, html) => {
        commit("updatingSystemTemplate", true);
        const toUpdate = {
          html: html,
          slotValues: state.currentSlotValues,
          updatedBy: rootGetters["user/getUser"].uid,
          dateUpdated: firebase.firestore.Timestamp.fromDate(new Date())
        };
        // console.log(toUpdate);
        return collection("emails/templates/system")
          .doc(state.currentTemplate.id)
          .update(toUpdate)
          .then(async () => {
            await hive.alert(`Template [${state.currentTemplate.name}] Saved!`);
            commit("updatingSystemTemplate", false);
          });
      }
    ),
    async selectSystemTemplate({ commit, state }, id) {
      if (id.id) id = id.id;
      let template;
      for (let i = 0; i < state.systemTemplates.length; i++) {
        const temp = state.systemTemplates[i];
        if (temp.id === id) {
          template = temp;
          break;
        }
      }
      console.log(template);
      if (!template) return;

      commit("setCurrentTemplate", template);
      commit("setIsCurrentTemplateSystem", true);
      if (template.slotValues) {
        // console.log(template.slotValues);
        commit("setCurrentSlotValues", template.slotValues);
      } else {
        commit("setCurrentSlotValues", {});
      }
      commit("setCurrentTemplateHtml", null);
      if (template.url) {
        const templateHtml = await api.general.getFileAsText(template.url);
        // console.log(templateHtml);
        commit("setCurrentTemplateHtml", templateHtml);
      }
    },
    setCurrentSlotValues({ commit }, slotValues) {
      commit("setCurrentSlotValues", slotValues);
    }
  },
  getters: {
    systemTemplates: state => state.systemTemplates,
    customTemplates: state => state.customTemplates,
    updatingSystemTemplate: state => state.updatingSystemTemplate,
    currentTemplate: state => state.currentTemplate,
    currentTemplateHtml: state => state.currentTemplateHtml,
    currentSlotValues: state => state.currentSlotValues,
    // changed: state => {
    //   if (state.currentTemplateHtml !== state.currentTemplate.html) {
    //     return true;
    //   }
    //   return !deepEqual(
    //     state.currentSlotValues,
    //     state.currentTemplate.slotValues
    //   );
    // },
    isCurrentTemplateSystem: state => state.isCurrentTemplateSystem,
    currentPreviewHtml: state =>
      state.currentRenderedHtml || state.currentTemplateHtml,
    currentRenderedHtml: state => state.currentRenderedHtml
  }
};
